
import {
  closeInfoPopup,
  toggleInfoPopup,
} from '../shared/infoPopup/infoPopupControllerActions';
import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import type { TaskListScreenModel } from './TaskListScreenModelScreen';

export class TaskListScreenController {
  constructor(private readonly model: TaskListScreenModel) {}

  handleNavigate = (direction: ArrowDirection) => {
    this.model.onNavigate?.(direction);
  };

  handleInfoButtonClick = () => {
    toggleInfoPopup(this.model);
  };

  handleInfoClose = () => {
    closeInfoPopup(this.model);
  };

  handleTaskClick = (taskIndex: number) => {
    if (this.model.tasks[taskIndex]?.completed) {
      return;
    }
    this.model.onTaskClick?.(taskIndex);
  };

  handleGoBack = () => {
    this.model.onGoBack?.();
  };
}
